import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import App from "./app/App";
import extractFeatureFlagsFromLocation from "../features/extractFeatureFlagsFromLocation";
import extractFeatureFlagsFromCookie from "../features/extractFeatureFlagsFromCookie";
import {CentredLoader} from "./elements/Loader";
import {useSubscription} from "./subscription/useSubscription";
import redirectToSignIn from "./Redirect";
import {HashRouter} from "react-router-dom";
import {
    activeInDevFeaturesFromCookie, activeInDevFeaturesFromLocalStorage, activeInDevFeaturesFromLocation,
    activeInDevFeaturesFromSessionStorage
} from "../features/ActiveInDevFeaturesReducers";
import extractFeatureFlagsFromStorage, {
    addFeatureFlagToStorage, removeFeatureFlagFromStorage
} from "../features/extractFeatureFlagsFromStorage";

const Root = () => {
    const dispatch = useDispatch();
    const signedOn = useSelector(state => state.userIdentity.signedOn);

    useSubscription("USER_IDENTITY", "/ui/api/userIdentity", 60);

    useEffect(() => {
        dispatch(activeInDevFeaturesFromLocation(extractFeatureFlagsFromLocation(window.location)));
        dispatch(activeInDevFeaturesFromCookie(extractFeatureFlagsFromCookie()));
        dispatch(activeInDevFeaturesFromLocalStorage(extractFeatureFlagsFromStorage(window.localStorage)));
        dispatch(activeInDevFeaturesFromSessionStorage(extractFeatureFlagsFromStorage(window.sessionStorage)));

        window.Feature = {
            enable(featureName) {
                document.cookie = 'activeInDevFeatures=' + featureName + ';path=/;max-age=604800';
                alert(featureName + ' for 1 week');
                location.reload();
            },

            enablePermanently(featureName) {
                addFeatureFlagToStorage(window.localStorage, featureName);
                location.reload();
            },

            enableForSession(featureName) {
                addFeatureFlagToStorage(window.sessionStorage, featureName);
                location.reload();
            },

            disable(featureName) {
                document.cookie = 'activeInDevFeatures=' + featureName + ';path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                removeFeatureFlagFromStorage(window.localStorage, featureName);
                removeFeatureFlagFromStorage(window.sessionStorage, featureName);
                alert(featureName + ' now disabled');
                location.reload();
            },
        };

        return () => {
            delete window.Feature;
        }
    }, []);

    useEffect(() => {
        if (signedOn === false) {
            redirectToSignIn(window);
        }
    }, [signedOn]);

    if (signedOn === false) {
        return null;
    } else if (signedOn === true) {
        return <HashRouter><App/></HashRouter>;
    } else {
        return <CentredLoader/>;
    }
};

export default Root;
